module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-down-+.477bc2d8.svg";